// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5090 ? "b5b14039" : chunkId) + "." + {"689":"67e50e0268cc65e6","5090":"8b4dce7b644159b8"}[chunkId] + ".js";
};